import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Contractor } from '../types/contractor'
import { Contract } from '../types/contracts'
import { ReceiptsCountSummary } from '../types/receipts-count-summary'

export interface UserState {
  username: string | null
  email: string | null
  phoneNumber: string | null
  contractors: Contractor[]
  contracts: Contract[]
  isEmailConfirmed: boolean
  isPhoneNumberConfirmed: boolean
  name: string | null
  taxId: string | null
  street: string | null
  city: string | null
  zipCode: string | null
  accountNumber: string | null
  receiptsCountSummary: ReceiptsCountSummary
}

const initialState: UserState = {
  username: null,
  email: null,
  phoneNumber: null,
  contractors: [],
  contracts: [],
  isEmailConfirmed: false,
  isPhoneNumberConfirmed: false,
  name: null,
  taxId: null,
  street: null,
  city: null,
  zipCode: null,
  accountNumber: null,
  receiptsCountSummary: {
    daysSummary: [],
    weeksSummary: [],
    monthsSummary: [],
    yearsSummary: [],
    allTimeNumber: 0
  }
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set: (state: UserState, action: PayloadAction<UserState>) => {
      const { username, phoneNumber, email, isEmailConfirmed, isPhoneNumberConfirmed, contractors, contracts, name, taxId, city, street, zipCode, accountNumber, receiptsCountSummary } = action.payload
      state.username = username
      state.phoneNumber = phoneNumber
      state.email = email
      state.contractors = contractors
      state.contracts = contracts
      state.isEmailConfirmed = isEmailConfirmed
      state.isPhoneNumberConfirmed = isPhoneNumberConfirmed
      state.name = name
      state.taxId = taxId
      state.city = city
      state.street = street
      state.zipCode = zipCode
      state.accountNumber = accountNumber
      state.receiptsCountSummary = receiptsCountSummary
    },
    reset: (state: UserState) => {
      state.username = null
      state.phoneNumber = null
      state.email = null
      state.contractors = []
      state.contracts = []
      state.isEmailConfirmed = false
      state.isPhoneNumberConfirmed = false
      state.name = null
      state.taxId = null
      state.city = null
      state.street = null
      state.zipCode = null
      state.accountNumber = null
      state.receiptsCountSummary = {
        daysSummary: [],
        weeksSummary: [],
        monthsSummary: [],
        yearsSummary: [],
        allTimeNumber: 0
      }
    }
  }
})

export const UserActions = userSlice.actions

export default userSlice.reducer
